/**
 * @module common/DualAxis/fields/AxisMetricSingleField
 * @description 组合图 · 指标单选
 */

import React from 'react';
import { useIntl } from 'umi';
import { Select } from 'tea-component';

interface ISelectOption {
  value: string;
  text: string;
}

interface IAxisMetricSingleFieldProps {
  value: string;
  options: ISelectOption[];
  onChange: (metric: string) => void;
  className?: string;
}

const AxisMetricSingleField: React.FC<IAxisMetricSingleFieldProps> = ({
  value,
  options,
  onChange,
  className = '',
}) => {
  const { formatMessage } = useIntl();

  return (
    <div className={`dbl-chart-setting-row ${className}`}>
      <div className="dbl-lable-gray-font">
        {formatMessage({ id: 'dbl_chart_primary_metic' })}
      </div>
      <Select
        size="full"
        matchButtonWidth
        appearance="button"
        options={options}
        value={value}
        onChange={onChange}
        placeholder={formatMessage({ id: 'dbl_chart_select_placeholder' })}
      />
    </div>
  );
};

export default React.memo(AxisMetricSingleField);
